module.exports = __webpack_public_path__ + "static/img/il-sole-24-ore.ed80fb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/il-sole-24-ore.png
// module id = lziP
// module chunks = 0